'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'edit',
  aliases: [],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF040',
    glyphName: 'pencil',
    transform: 'scale(1,-1) translate(0, -1536)',
    horizAdvX: '1536',
    d: 'M363 0l91 91l-235 235l-91 -91v-107h128v-128h107zM886 928q0 22 -22 22q-10 0 -17 -7l-542 -542q-7 -7 -7 -17q0 -22 22 -22q10 0 17 7l542 542q7 7 7 17zM832 1120l416 -416l-832 -832h-416v416zM1515 1024q0 -53 -37 -90l-166 -166l-416 416l166 165q36 38 90 38\nq53 0 91 -38l235 -234q37 -39 37 -91z'
  }),
  viewBox: '0 128 1536 1536'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/edit.js
// module id = 1587
// module chunks = 0